import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";

const WordsCounter = () => {
  const [inputText, setInputText] = useState("");
  const [statistics, setStatistics] = useState(null);

  const calculateStatistics = () => {
    if (!inputText.trim()) {
      alert("Please enter some text.");
      return;
    }

    const words = inputText.trim().split(/\s+/);
    const sentences = inputText.split(/[.!?]+/).filter((sentence) => sentence.trim().length > 0);
    const characters = inputText.replace(/\s+/g, "");
    const paragraphs = inputText.split(/\n+/).filter((paragraph) => paragraph.trim().length > 0);

    const wordFrequency = {};
    words.forEach((word) => {
      const cleanedWord = word.toLowerCase().replace(/[^\w]/g, ""); // Clean punctuation
      if (cleanedWord) {
        wordFrequency[cleanedWord] = (wordFrequency[cleanedWord] || 0) + 1;
      }
    });

    const sortedKeywords = Object.entries(wordFrequency)
      .sort(([, a], [, b]) => b - a)
      .slice(0, 6) // Top 6 keywords
      .map(([word, count]) => ({
        word,
        count,
        percentage: ((count / words.length) * 100).toFixed(2),
      }));

    setStatistics({
      words: words.length,
      sentences: sentences.length,
      characters: characters.length,
      paragraphs: paragraphs.length,
      keywords: sortedKeywords,
    });
  };

  return (
    <div className="container mt-5">
      <h2 className="text-center mb-4">Words Counter Tool</h2>

      <div className="mb-3">
        <textarea
          className="form-control"
          rows="6"
          placeholder="Paste your text here..."
          value={inputText}
          onChange={(e) => setInputText(e.target.value)}
        ></textarea>
      </div>

      <button className="btn btn-primary w-100 mb-4" onClick={calculateStatistics}>
        Check Now
      </button>

      {statistics && (
        <div className="results mt-4">
          <h4>Text Analysis Results:</h4>
          <table className="table table-bordered mt-3">
            <thead>
              <tr>
                <th>Statistic</th>
                <th>Count</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Words</td>
                <td>{statistics.words}</td>
              </tr>
              <tr>
                <td>Sentences</td>
                <td>{statistics.sentences}</td>
              </tr>
              <tr>
                <td>Characters</td>
                <td>{statistics.characters}</td>
              </tr>
              <tr>
                <td>Paragraphs</td>
                <td>{statistics.paragraphs}</td>
              </tr>
            </tbody>
          </table>

          <h5 className="mt-4">Top 6 Keywords by Density:</h5>
          <table className="table table-bordered mt-3">
            <thead>
              <tr>
                <th>Keyword</th>
                <th>Count</th>
                <th>Percentage</th>
              </tr>
            </thead>
            <tbody>
              {statistics.keywords.map((keyword, index) => (
                <tr key={index}>
                  <td>{keyword.word}</td>
                  <td>{keyword.count}</td>
                  <td>{keyword.percentage}%</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default WordsCounter;
